import type { ReactNode } from "react"

import { CategoryCssInjector } from "@/components/category-css-injector"
import { DisclaimerProvider } from "@/components/disclaimer-provider"
import { SmsTwoFactorReminder } from "@/components/sms-two-factor-reminder"
import { Toaster } from "@/components/ui/sonner"
import { useFlash } from "@/hooks/use-flash"

interface PersistentLayoutProps {
  children: ReactNode
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash()
  return (
    <DisclaimerProvider>
      <CategoryCssInjector />
      {children}
      <SmsTwoFactorReminder />
      <Toaster richColors />
    </DisclaimerProvider>
  )
}
